import { datatableTypes } from '@/typings'

export const getValidatedFilters = (filters?: datatableTypes.DatatableFilter[]) => {
	if (!filters) {
		return []
	}
	return filters.filter((_, index) => {
		if (index === 0) {
			return true
		}

		if (index > 0) {
			const { value } = filters[index - 1]
			if (typeof value === 'string') {
				return value.length
			}

			return !!value
		}

		return false
	})
}
